<template>
  <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="delete-modal">
      <div class="flex flex-col gap-5 text-left">
        <div class="flex justify-between">
          <div class="flex gap-4">
            <svg
              width="15"
              height="19"
              viewBox="0 0 15 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.0601 8.10944C11.0601 10.0416 9.56772 11.6079 7.72677 11.6079C5.88583 11.6079 4.39345 10.0416 4.39345 8.10944C4.39345 6.17732 5.88583 4.61102 7.72677 4.61102C9.56772 4.61102 11.0601 6.17732 11.0601 8.10944ZM9.39344 8.10944C9.39344 9.0755 8.64725 9.85865 7.72677 9.85865C6.8063 9.85865 6.06011 9.0755 6.06011 8.10944C6.06011 7.14338 6.8063 6.36023 7.72677 6.36023C8.64725 6.36023 9.39344 7.14338 9.39344 8.10944Z"
                fill="#4285F5"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.32847 13.5723C-0.671463 10.5747 -0.788013 5.5923 2.06815 2.44379C4.9243 -0.704719 9.6716 -0.827041 12.6715 2.17058C15.6715 5.16819 15.788 10.1506 12.9319 13.2991L7.76032 19L2.32847 13.5723ZM11.7248 12.093L7.70247 16.527L3.4777 12.3055C1.14442 9.97399 1.05377 6.09878 3.27522 3.64994C5.49668 1.2011 9.18902 1.10596 11.5223 3.43744C13.8556 5.76892 13.9462 9.64413 11.7248 12.093Z"
                fill="#4285F5"
              />
            </svg>
            <div class="flex flex-col gap-2">
              <span class="text-lightGrey">Pickup Location</span>
              <span
                style="background:rgb(242, 247, 252); width: 100vw;
                  display: block;
                  padding: 0.7rem;
                  border-radius: 5px;
                "
                >{{ formatAddress(booking.shipperlocation.address) }}</span
              >
            </div>
          </div>
        </div>
        <div class="flex justify-between tb-border">
          <div class="flex gap-4 items-center">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.8">
                <path
                  d="M9.49967 12.6668C11.2486 12.6668 12.6663 11.2491 12.6663 9.50016C12.6663 7.75126 11.2486 6.3335 9.49967 6.3335C7.75077 6.3335 6.33301 7.75126 6.33301 9.50016C6.33301 11.2491 7.75077 12.6668 9.49967 12.6668Z"
                  fill="#09B78A"
                />
                <path
                  d="M10.2913 3.22145V1.5835H8.70801V3.22145C7.31491 3.39933 6.02027 4.03463 5.02721 5.0277C4.03414 6.02076 3.39884 7.3154 3.22097 8.7085H1.58301V10.2918H3.22097C3.39858 11.685 4.0338 12.9798 5.02691 13.9729C6.02003 14.966 7.31481 15.6013 8.70801 15.7789V17.4168H10.2913V15.7789C11.6846 15.6014 12.9794 14.9662 13.9726 13.9731C14.9657 12.9799 15.6009 11.6851 15.7784 10.2918H17.4163V8.7085H15.7784C15.6008 7.3153 14.9655 6.02052 13.9724 5.0274C12.9793 4.03429 11.6845 3.39907 10.2913 3.22145ZM9.49967 14.2502C6.88005 14.2502 4.74967 12.1198 4.74967 9.50016C4.74967 6.88054 6.88005 4.75016 9.49967 4.75016C12.1193 4.75016 14.2497 6.88054 14.2497 9.50016C14.2497 12.1198 12.1193 14.2502 9.49967 14.2502Z"
                  fill="#09B78A"
                />
              </g>
            </svg>

            <div class="flex flex-col gap-2">
              <span class="text-lightGrey">3pl Hand off</span>
              <span
                style="
                  background: rgb(242, 247, 252);
                  width: 100vw;
                  display: block;
                  padding: 0.7rem;
                  border-radius: 5px;
                "
              ></span>
            </div>
          </div>
        </div>
        <div class="flex justify-between">
          <div class="flex gap-4 items-end">
            <svg
              width="15"
              height="19"
              viewBox="0 0 15 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.0601 8.10944C11.0601 10.0416 9.56772 11.6079 7.72677 11.6079C5.88583 11.6079 4.39345 10.0416 4.39345 8.10944C4.39345 6.17732 5.88583 4.61102 7.72677 4.61102C9.56772 4.61102 11.0601 6.17732 11.0601 8.10944ZM9.39344 8.10944C9.39344 9.0755 8.64725 9.85865 7.72677 9.85865C6.8063 9.85865 6.06011 9.0755 6.06011 8.10944C6.06011 7.14338 6.8063 6.36023 7.72677 6.36023C8.64725 6.36023 9.39344 7.14338 9.39344 8.10944Z"
                fill="#EB4335"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.32847 13.5723C-0.671463 10.5747 -0.788013 5.5923 2.06815 2.44379C4.9243 -0.704719 9.6716 -0.827041 12.6715 2.17058C15.6715 5.16819 15.788 10.1506 12.9319 13.2991L7.76032 19L2.32847 13.5723ZM11.7248 12.093L7.70247 16.527L3.4777 12.3055C1.14442 9.97399 1.05377 6.09878 3.27522 3.64994C5.49668 1.2011 9.18902 1.10596 11.5223 3.43744C13.8556 5.76892 13.9462 9.64413 11.7248 12.093Z"
                fill="#EB4335"
              />
            </svg>

            <div class="flex flex-col gap-2">
              <span class="text-lightGrey">Delivery Location</span>
              <span
                style="background: rgb(242, 247, 252);
                  width: 100vw;
                  display: block;
                  padding: 0.7rem;
                  border-radius: 5px;
                "
              >
                {{ formatAddress(booking.consigneelocation.address) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-2 my-4">
      <span class="text-lightGrey">Route Type:</span>
      <span>Inter State</span>
    </div>
    
    <gmap-map
      :center="center"
      @place_changed="setPlace"
      :zoom="12"
      style="width: 100%; height: 400px"
    >
      <directions-renderer
        travelMode="DRIVING"
        :origin="origin"
        :destination="destination"
      />
    </gmap-map>
  </modal>
</template>

<script>
import DirectionsRenderer from "./DirectionsRenderer";
export default {
  components: { DirectionsRenderer },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      requred: true,
    },
  },
  data() {
    return {
      center: {
        lat: this.booking.shipperlocation?.address.lat
          ? this.booking.shipperlocation?.address.lat
          : 0,
        lng: this.booking.shipperlocation?.address.lng
          ? this.booking.shipperlocation?.address.lng
          : 0,
      },
      markers: [],
      currentPlace: null,
    };
  },
  computed: {
    origin() {
      return {
        lat: this.booking.shipperlocation?.address.lat
          ? this.booking.shipperlocation?.address.lat
          : 0,
        lng: this.booking.shipperlocation?.address.lng
          ? this.booking.shipperlocation?.address.lng
          : 0,
      };
    },
    destination() {
      return {
        lat: this.booking.consigneelocation?.address.lat
          ? this.booking.consigneelocation.address.lat
          : 0,
        lng: this.booking.consigneelocation?.address.lng
          ? this.booking.consigneelocation?.address.lng
          : 0,
      };
    },
    path() {
      return [
        {
          lat: this.booking.shipperlocation?.address.lat
            ? this.booking.shipperlocation?.address.lat
            : 0,
          lng: this.booking.shipperlocation?.address.lng
            ? this.booking.shipperlocation?.address.lng
            : 0,
        },
        {
          lat: this.booking.consigneelocation?.address.lat
            ? this.booking.consigneelocation?.address.lat
            : 0,
          lng: this.booking.consigneelocation?.address.lng
            ? this.booking.consigneelocation?.address.lng
            : 0,
        },
      ];
    },
  },
  mounted() {
    this.geolocate();
  },

  methods: {
    setPlace(place) {
      this.currentPlace = place;
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
  
      this.markers = [
        {
          lat: this.booking.shipperlocation?.address.lat
            ? this.booking.shipperlocation?.address.lat
            : 0,
          lng: this.booking.shipperlocation?.address.lng
            ? this.booking.shipperlocation?.address.lng
            : 0,
          label: this.booking.shipperlocation?.address.name
            ? this.booking.shipperlocation?.address.name
            : this.booking.shipperlocation?.address,
        },
        {
          lat: this.booking.consigneelocation?.address.lat
            ? this.booking.consigneelocation?.address.lat
            : 0,
          lng: this.booking.consigneelocation?.address.lng
            ? this.booking.consigneelocation?.address.lng
            : 0,
          label: this.booking.consigneelocation?.address.name
            ? this.booking.consigneelocation?.address.name
            : this.booking.consigneelocation?.address,
        },
      ];
    },
  },
};
</script>
